<div class="license-tab">
  <div class="row">
    <!-- Left Column -->
    <div class="col-md-6">
      <div class="form-group">
        <label class="col-md-6 control-label" for="stateOfRegistration"
          >STATE OF REGISTRATION</label
        >
        <div class="col-md-6 inputSpace">
          <select
            id="stateOfRegistration"
            name="stateOfRegistration"
            class="form-control"
            [(ngModel)]="tractor.stateOfRegistration"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          >
            <option value="">Select State</option>
            <option *ngFor="let option of stateOptions" [ngValue]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="licenseNumber">LICENSE PLATE</label>
        <div class="col-md-6 inputSpace">
          <input
            id="licenseNumber"
            name="licenseNumber"
            type="text"
            class="form-control"
            [(ngModel)]="tractor.licenseNumber"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="licenseExpirationDate"
          >LICENSE EXPIRATION DATE</label
        >
        <div class="col-md-6 inputSpace">
          <input
            id="licenseExpirationDate"
            name="licenseExpirationDate"
            type="text"
            class="form-control"
            [inputMask]="dateInputMask"
            placeholder="mm/dd/yyyy"
            [(ngModel)]="tractor.licenseExpirationDate"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>
    </div>
  </div>
</div>
